/* eslint-disable */
import AppHeader from "@saleor/components/AppHeader";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormSpacer from "@saleor/components/FormSpacer";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { getFormErrors } from "@saleor/utils/errors";
import { maybe } from "@saleor/misc";
import { ReorderAction } from "@saleor/types";
import { useIntl } from "react-intl";
import { EmailSettingUpdate_emailSettingUpdate_errors } from "../../types/EmailSettingUpdate";
import MultimediaEditor from "@saleor/components/MultimediaEditor";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";

//引入相关组件
// import { EditorState, convertToRaw, ContentState } from "draft-js"; //convertToRaw
// import { Editor } from "react-draft-wysiwyg";
// import draftToHtml from "draftjs-to-html"; //获取编辑器html内容
// import htmlToDraft from "html-to-draftjs"; //将html内容转为编辑器显示内容
// // import draftToMarkdown from 'draftjs-to-markdown' //获取编辑框得内容
// //引入样式
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// import { Editor } from '@tinymce/tinymce-react';

export interface RotaryPageProps {
  emailSettingData: emailTemplateDetailFormData | null;
  disabled: boolean;
  errors: EmailSettingUpdate_emailSettingUpdate_errors[];
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onDelete: () => void;
  onDefault: () => void;
  onTest: (name: String) => void;
  onSubmit: (data: emailTemplateDetailFormData) => void;
  onItemsAdd: () => void;
  onValueDelete: (id: string) => void;
  onValueReorder: ReorderAction;
  onValueUpdate: (id: string) => void;
}

export interface emailTemplateDetailFormData {
  description: string;
  emailType: string;
  id: string;
  lastChange: string;
  name: string;
  sendFrequency: number;
  subject: string;
  template: string;
}

const EmailTemplateDetailForm: React.FC<RotaryPageProps> = ({
  emailSettingData,
  disabled,
  errors,
  saveButtonBarState,
  onBack,
  onSubmit,
  onTest,
  onDefault
}) => {
  const intl = useIntl();
  const initialForm: emailTemplateDetailFormData = {
    description: maybe(() => emailSettingData.description, ""),
    emailType: maybe(() => emailSettingData.emailType, ""),
    id: maybe(() => emailSettingData.id, ""),
    lastChange: maybe(() => emailSettingData.lastChange, ""),
    name: maybe(() => emailSettingData.name, ""),
    sendFrequency: maybe(() => emailSettingData.sendFrequency, 0),
    subject: maybe(() => emailSettingData.subject, ""),
    template: maybe(() => emailSettingData.template, "")
  };

  // const editorRef = useRef(null);
  const [dirty, setDirty] = useState(false);
  return (
    <Form initial={initialForm} onSubmit={onSubmit}>
      {({ change, data, hasChanged, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>{"Email Templates"}</AppHeader>
          <PageHeader title={data.name} />
          <Grid>
            <Card>
              <CardContent>
                <TextField
                  disabled={disabled}
                  error={!!getFormErrors(["subject"], errors).subject}
                  label={intl.formatMessage({
                    defaultMessage: "Subject",
                    description: "Subject"
                  })}
                  name={"subject" as keyof emailTemplateDetailFormData}
                  fullWidth
                  value={data.subject}
                  onChange={change}
                />
                <FormSpacer />
                {emailSettingData?.emailType &&
                emailSettingData?.emailType == "TASK" ? (
                  <TextField
                    error={
                      !!getFormErrors(["sendFrequency"], errors).sendFrequency
                    }
                    disabled={disabled}
                    label={intl.formatMessage({
                      defaultMessage: "Send frequency(hours)",
                      description: "Send frequency(hours)"
                    })}
                    name={"sendFrequency" as keyof emailTemplateDetailFormData}
                    fullWidth
                    value={data.sendFrequency}
                    onChange={change}
                  />
                ) : (
                  emailSettingData?.name == "account_subscribed" && (
                    <ControlledCheckbox
                      checked={Boolean(data.sendFrequency)}
                      label={intl.formatMessage({
                        defaultMessage: "Active",
                        description: "just aff url can use it"
                      })}
                      name={
                        "sendFrequency" as keyof emailTemplateDetailFormData
                      }
                      onChange={change}
                    />
                  )
                )}
                <FormSpacer />
                <MultimediaEditor
                  initialValue={data.template}
                  setDirty={setDirty}
                  dirty={dirty}
                  editorName={"Email Template"}
                  update={newtemplate => {
                    const data = {
                      target: {
                        name: "template",
                        value: newtemplate
                      }
                    };
                    change(data);
                  }}
                />
                <FormSpacer />
                {data.template === "" && (
                  <Button
                    onClick={onDefault}
                    disabled={data.template !== ""}
                    variant="text"
                    color="primary"
                    data-test="button"
                  >
                    Initialize Button
                  </Button>
                )}
                <Button
                  onClick={() => onTest(data.name)}
                  disabled={false}
                  variant="text"
                  color="primary"
                  data-test="button"
                >
                  Send Test
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <SaveButtonBar
            disabled={disabled || (!hasChanged && !dirty)}
            state={saveButtonBarState}
            onCancel={onBack}
            onSave={submit}
            onDelete={undefined}
          />
        </Container>
      )}
    </Form>
  );
};
EmailTemplateDetailForm.displayName = "EmailTemplateDetailForm";
export default EmailTemplateDetailForm;
